
// src/actions/images-view.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_CHAT_IMAGES_VIEW = "FETCH_CHAT_IMAGES_VIEW"
export const FETCH_GROUP_TIMELINE_IMAGES_VIEW = "FETCH_GROUP_TIMELINE_IMAGES_VIEW"
export const FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW = "FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW"
export const FETCH_IMAGES_VIEW_REQUESTED = "FETCH_IMAGES_VIEW_REQUESTED"
export const FETCH_IMAGES_VIEW_COMPLETED = "FETCH_IMAGES_VIEW_COMPLETED"
export const FETCH_IMAGES_VIEW_FAILED = "FETCH_IMAGES_VIEW_FAILED"
export const CLEAR_IMAGES_VIEW = "CLEAR_IMAGES_VIEW"

const FETCH_IMAGES_VIEW_LENGTH = 100

export function fetchImagesViewRequested() {
  return {
    type: FETCH_IMAGES_VIEW_REQUESTED
  }
}

export function fetchChatImagesView(chat_room_id) {
  return function(dispatch) {
    dispatch(fetchImagesViewRequested())
    return api.get(`/attachments`, { chat_room_id, length:  FETCH_IMAGES_VIEW_LENGTH})
        .then((results)=> {
          dispatch(fetchImagesViewCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchImagesViewFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupTimelineImagesView(diary_id, all_file) {
  return function(dispatch) {
    dispatch(fetchImagesViewRequested())
    return api.get(`/attachments`, { diary_id, length: FETCH_IMAGES_VIEW_LENGTH, all_files: all_file })
        .then((results)=> {
          dispatch(fetchImagesViewCompleted(results.reverse()))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchImagesViewFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupTimelineCommentImagesView(comment_id) {
  return function(dispatch) {
    dispatch(fetchImagesViewRequested())
    return api.get(`/attachments`, { comment_id, length: FETCH_IMAGES_VIEW_LENGTH })
        .then((results)=> {
          dispatch(fetchImagesViewCompleted(results.reverse()))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchImagesViewFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchImagesViewCompleted(results) {
  return {
    type: FETCH_IMAGES_VIEW_COMPLETED,
    results,
  }
}

export function fetchImagesViewFailed(error) {
  return {
    type: FETCH_IMAGES_VIEW_FAILED,
    error,
  }
}

export function clearImagesView() {
  return {
    type: CLEAR_IMAGES_VIEW
  }
}


// WEBPACK FOOTER //
// ./src/actions/images-view.js